/**
 * Gets the current store id from either dutchie or jane global window objects
 */
export function getCurrentStoreId() {
  if(window.jointDutchie?.currentStore?.joint_business_id) {
    return window.jointJane?.currentStore?.joint_business_id
  }
  if(window.jointJane?.currentStore?.joint_business_id) {
    return window.jointJane?.currentStore?.joint_business_id
  }
  return null;
}

/**
 * Gets the global theme settings
 */
export function getJointTheme() {
  return window.joint.theme;
}
